var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page-edit',{attrs:{"title":_vm.title,"nameRoleEntity":_vm.nameRoleEntity,"apiNameGet":_vm.apiNameGet,"apiNameCreate":_vm.apiNameCreate,"apiNameUpdate":_vm.apiNameUpdate,"routeNameShow":"ShowAttrEntity","routeNameCreate":"CreateAttrEntity","keyRoute":'AttrEntityId',"backUrl":'/attrentity',"hasLang":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }